/*global REACT_APP_API_BASE_URL_NEW:true*/
import request from "@/utils/request";

export async function getAllAdminRoles() {
  const result = request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/roles/admin`, {
    method: "GET",
  });

  return (await result).data;
}

export async function getAllUsersRoles(roleType) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/identity-service/roles`, {
    params: { type: roleType },
    method: "GET",
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
